import React, { FC, useEffect, useState } from "react";
import { usePagination } from "../../contexts/table/PaginationContext";
import { matchesOptionValue } from "../../utilities/genericUtil";
import Paginator from "../paginator/paginator";
import SearchField from "../search-field/search-field";
import List from "../list/list2";

type Props = {
    items: any[];
    onSelect: (index: number, item: any) => void;
    isStriped?: boolean;
    isMultiSelect?: boolean;
    selectedItems?: number[] | string[];
    onSearch?: (searchTerm) => void;
    searchable?: boolean;
};

const PaginatedSearchableList: FC<Props> = ({ items, onSelect, isStriped = true, isMultiSelect = false, selectedItems = new Array(0), onSearch = (searchTerm: string) => { }, searchable = true}) => {
    const [listItems, setListItems] = useState(new Array(0));
    const paginationContext = usePagination();

    const buildListItem = (item, index) => {
        return {
            value: item.value,
            isSelected: selectedItems.some((selectedItem) => matchesOptionValue(selectedItem, item.value)),
            label: item.label,
            elementSysname: item.elementSysname,
            site: item.site,
            optionalColumns: item.optionalColumns
        };
    };

    useEffect(() => {
        setListItems(items.map(buildListItem));
    }, [items, selectedItems]);

    return (
        <>
            {searchable && <SearchField setSearchTerm={onSearch} className={'mx-1'} cyName="paginated"/>}
            <Paginator  itemCount={listItems.length} onPageNumberUpdated={paginationContext.updatePageNumber} paginationObj={paginationContext.pagination}>
                {({ start, end }) =>
                    <div
                        id="paginatedList"
                        data-cy="paginatedList"
                        className={isStriped
                            ? `text-gray-700 p-1`
                            : `text-black p-1`}>
                        <List
                            onSelect={(index, item) => onSelect(index, item)}
                            isStriped={isStriped}
                            items={listItems}
                            isMultiSelect={isMultiSelect}
                            stripedListItemClassName="p-1 pl-3"
                            selectedListItemClassName="p-1 pl-1-5 border-l-7 border-portal-blue-primary bg-selection-highlight border-t-selection-highlight border-r-selection-highlight border-b-selection-highlight">
                        </List>
                    </div>
                }
            </Paginator>
        </>
    );
};

export default PaginatedSearchableList;